const e = {
  "cdr-skeleton": "cdr-skeleton_15-5-1"
};
export {
  e as default
};
